export default "__VITE_ASSET__Cmi6RD45__"